'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addWeeks;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/addWeeks.js
// module id = 161
// module chunks = 1